import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const OptionalHint = styled.span`
	color: ${helpers.color.input.hint};
	flex-shrink: 0;
	font-family: ${helpers.font.family.base};
	font-size: 12px;
`
